import { getShift } from '../api/getShift';
import {setGetShiftAction} from '../action';

const setGetShift = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getShift(params);

            if (data.status === 'success') {
                dispatch(setGetShiftAction({
                    data: data.data,
                    countPage: data.countPage
                }))
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetShift
}